import { InjectionToken, Provider } from '@angular/core';
import { ActionReducerMap } from '@ngrx/store';
import { MobileMenuState } from '../mobile-menu-state';
import { initialState as initialMobileMenuState, reducer as mobileMenuReducer } from './mobile-menu.reducer';

export const initialState: MobileMenuState = {
  mobileMenu: initialMobileMenuState,
};

export function getReducers(): ActionReducerMap<MobileMenuState> {
  return {
    mobileMenu: mobileMenuReducer,
  };
}

export const reducerToken: InjectionToken<ActionReducerMap<MobileMenuState>> = new InjectionToken<
  ActionReducerMap<MobileMenuState>
>('MobileMenuReducers');

export const reducerProvider: Provider = {
  provide: reducerToken,
  useFactory: getReducers,
};
